var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "prize-list-wrap"
  }, [_c('v-row', {
    staticClass: "prize-list"
  }, [_vm._l(_vm.items, function (item) {
    return [_c('v-col', {
      key: item,
      staticClass: "prize-list__item",
      attrs: {
        "cols": "6",
        "md": "4"
      }
    }, [_c('v-img', {
      staticClass: "d-lg-none",
      attrs: {
        "src": item.mobile,
        "alt": item.alt
      }
    }), _c('v-img', {
      staticClass: "d-none d-lg-block",
      attrs: {
        "src": item.image,
        "alt": item.alt
      }
    })], 1)];
  })], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }